export const ConsultationEvaluationCn = {
    xunjiadang:'咨询评价',
    fanhui:'返回',
    wodepingjia:'我的评价',
    wodezhuiping:'我的追评',
    daipinjiadingdang:'待评价订单',
    zuanjiaxinxi:'专家信息',
    pingjianeirong:'评价内容',
    pingjiazuantai:'评价状态',
    wodepingjia:'我的评价',
    sangjiapingjia:'商家评价',
    pingtaihuifu:'平台回复',
    jiage:'价格',
    zixunjindu:'评价状态',
    caozuo:'操作'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/ConsultationEvaluation/ConsultationEvaluationCn.js